import { ref, defineComponent, computed } from "vue";
import { a as mdiCheck, j as mdiContentCopy } from "./mdi-C_j0YT8c.mjs";
import { toValue, whenever } from "@vueuse/core";
import { N as NcFormBoxButton } from "./NcFormBoxButton-DN0-J4yN.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-BreCg8pX.mjs";
import { r as register, a as t } from "./_l10n-BmKQgz1z.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register();
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const DELAY = 2e3;
function useCopy(content) {
  const isCopied = ref(false);
  async function copy() {
    if (isCopied.value) {
      return;
    }
    const value = toValue(content);
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      prompt("", value);
    }
    isCopied.value = true;
    setTimeout(() => {
      isCopied.value = false;
    }, DELAY);
  }
  return {
    isCopied,
    copy
  };
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBoxCopyButton",
  props: {
    label: { default: void 0 },
    value: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["copy"],
  setup(__props, { emit }) {
    const props = __props;
    const { isCopied, copy } = useCopy(() => props.value);
    const icon = computed(() => isCopied.value ? mdiCheck : mdiContentCopy);
    whenever(isCopied, () => emit("copy"));
    return { __sfc: true, props, emit, isCopied, copy, icon, NcFormBoxButton, NcIconSvgWrapper, t };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcFormBoxButton, { attrs: { "disabled": _vm.disabled, "inverted-accent": "" }, on: { "click": _setup.copy }, scopedSlots: _vm._u([_vm.$slots.default || _vm.label ? { key: "default", fn: function() {
    return [_c("span", { staticClass: "hidden-visually" }, [_vm._v(" " + _vm._s(_setup.isCopied ? _setup.t("Copied") : _setup.t("Copy to clipboard")) + " ")]), _vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    })];
  }, proxy: true } : null, { key: "description", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.value) + " ")];
  }, proxy: true }, { key: "icon", fn: function() {
    return [_c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.icon, "inline": "" } })];
  }, proxy: true }], null, true) });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcFormBoxCopyButton = __component__.exports;
export {
  NcFormBoxCopyButton as N
};
//# sourceMappingURL=NcFormBoxCopyButton-Dwrfiovz.mjs.map
